import {
  updateLocationsAndCategory,
  updateOrganizer,
  updateOutlookInfo,
  updateTimeOfOutlook,
  updateOrgInfo,
} from "@/redux/slices/organizations/OrganizationSlice";
import { updateSettings } from "@/redux/slices/settings/SettingSlice";
import { connect } from "react-redux";
import ResourceFloorPlanInitial from "./index";
import { OutLookInfo } from "@/services/organization-service/entity/OutLookEntity";
import {
  IFilterResource,
  IResourceService,
  ISessionData,
  OrganizationInfo,
  Organizer,
  ResourceInfo,
  ResourceService,
} from "@/services";
import { DateTimePeriodDto } from "@/index";
import { Dispatch } from "@reduxjs/toolkit";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { ICategorizationInfo, ITreeInfo } from "@/components/ui/TreeSelect/Models";
import { updateAllResourcesDataInSelectedChangeRsOutlook, updateFilterResource } from "@/redux/slices/resources/ResourceSlice";
import { DateTimeFormat } from "@/services/setting-service/entity/SettingResponseModel";

const mapDispatchToProps = (dispatch: Dispatch) => {
  const resourceService: IResourceService = new ResourceService();
  return {
    getCategorization: (
      locationTrees: ITreeInfo[],
      categoryTrees: ITreeInfo[],
      locationList: ICategorizationInfo[]
    ) => {
      dispatch(updateLocationsAndCategory({locationTrees, categoryTrees, locationList}));
    },
    updateOutlookInfo: (outlookInfo: OutLookInfo) => {
      dispatch(updateOutlookInfo(outlookInfo));
    },
    updateOrganizer: (org: Organizer) => {
      dispatch(updateOrganizer(org));
    },
    updateTimeOfOutlook: (time: DateTimePeriodDto) => {
      dispatch(updateTimeOfOutlook(time));
    },
    updateSettings: (settingInfo: ISettingStore) => {
      dispatch(updateSettings(settingInfo));
    },
    updateOrgInfo: (orgInfo: OrganizationInfo) => {
      dispatch(updateOrgInfo(orgInfo));
    },
    updateAllResourcesSelectedFromParent: (resources: ResourceInfo[]) => {
      dispatch(updateAllResourcesDataInSelectedChangeRsOutlook(resources))
    },
    onGetDataSessionFloorPlan: (
      sessionId: string
    ): Promise<HttpResponse<ISessionData>> => {
      return resourceService
        .fetchSessionDataForFloorPlanDialog(sessionId)
        .then((resp) => {
          if(resp.data.token) {
            window.axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + resp.data.token;
            window.axiosInstance.defaults.headers.common["timezone"] =
            resp.data.timezone;
          }
          resp.data.settingInfo = {
            ...(resp.data.settingInfo || {}),
            dateTimeFormat: new DateTimeFormat(resp.data?.settingInfo?.dateTimeFormat)
          }
          return resp;
        });
    },
    onUpdateFilterResource: (filter: IFilterResource) => {
      dispatch(updateFilterResource(filter))
    }
  };
};

export default connect(null, mapDispatchToProps)(ResourceFloorPlanInitial);
